import {
  CROPDIALOG_DIALOG_OPEN,
  CROPDIALOG_DIALOG_CLOSE
} from "types/actions/crop-dialog-dialog"
import defer from "promise-defer"

let deferred

export const openCropDialogDialog = data => dispatch => {
  dispatch({ type: CROPDIALOG_DIALOG_OPEN, open: true, data })
  deferred = defer()
  return deferred.promise
}

export const closeCropDialogDialog = data => dispatch => {
  dispatch({ type: CROPDIALOG_DIALOG_CLOSE, open: false, data: {} })
  if (data) {
    deferred.resolve(data)
  } else {
    return deferred.reject()
  }
}



// WEBPACK FOOTER //
// ./src/actions/crop-dialog-dialog.js